"use client";

import { useRef } from "react";
import { ArrowUpRight } from "lucide-react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
gsap.registerPlugin(useGSAP, ScrollTrigger);
export default function ContactConsultation() {
  const container = useRef<HTMLDivElement>(null);
  useGSAP(() => {
    const el = container.current;
    if (!el) return;
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".vault-eyebrow", {
        y: 16
      });
      gsap.set(".vault-headline-line", {
        y: 32
      });
      gsap.set(".vault-body", {
        y: 20
      });
      gsap.set(".vault-cta", {
        y: 20
      });
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: el,
          start: "top 78%",
          once: true
        },
        defaults: {
          ease: "power3.out"
        }
      });
      tl.to(".vault-eyebrow", {
        opacity: 1,
        y: 0,
        duration: 0.6
      }).to(".vault-headline-line", {
        opacity: 1,
        y: 0,
        duration: 0.7,
        stagger: 0.08
      }, "-=0.25").to(".vault-body", {
        opacity: 1,
        y: 0,
        duration: 0.6
      }, "-=0.35").to(".vault-cta", {
        opacity: 1,
        y: 0,
        duration: 0.6
      }, "-=0.4");
      gsap.to(".vault-glow", {
        opacity: 0.65,
        duration: 2.4,
        ease: "sine.inOut",
        yoyo: true,
        repeat: -1
      });
      gsap.to(".vault-disc-a", {
        y: -30,
        scrollTrigger: {
          trigger: el,
          start: "top bottom",
          end: "bottom top",
          scrub: true
        }
      });
      gsap.to(".vault-disc-b", {
        y: 40,
        scrollTrigger: {
          trigger: el,
          start: "top bottom",
          end: "bottom top",
          scrub: true
        }
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".vault-eyebrow", ".vault-headline-line", ".vault-body", ".vault-cta"], {
        opacity: 1,
        y: 0
      });
      gsap.set(".vault-glow", {
        opacity: 0.5
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  return <section data-section-id="31122" id="contactconsultationcta" data-nav="dark" ref={container} className="bg-primary text-primary-foreground relative w-full overflow-hidden">
      {}
      <div aria-hidden="true" className="absolute inset-0 pointer-events-none" style={{
      background: "radial-gradient(ellipse 80% 60% at 50% 30%, hsl(215 80% 20%) 0%, hsl(215 90% 15%) 55%, hsl(220 22% 6%) 100%)"
    }} />

      {}
      <div aria-hidden="true" className="vault-disc-a absolute left-[15%] top-[18%] h-[340px] w-[340px] rounded-lg" style={{
      background: "radial-gradient(circle at 30% 30%, hsl(215 90% 45% / 0.55), hsl(215 80% 20% / 0.15) 60%, transparent 75%)",
      filter: "blur(4px)"
    }} />
      <div aria-hidden="true" className="vault-disc-b absolute right-[10%] bottom-[15%] h-[420px] w-[420px] rounded-lg" style={{
      background: "radial-gradient(circle at 60% 40%, hsl(210 20% 98% / 0.35), hsl(215 90% 45% / 0.18) 55%, transparent 75%)",
      filter: "blur(4px)"
    }} />
      <div aria-hidden="true" className="absolute left-[42%] top-[55%] h-[260px] w-[260px] rounded-lg" style={{
      background: "radial-gradient(circle at 50% 50%, hsl(215 90% 45% / 0.28), transparent 70%)",
      filter: "blur(6px)"
    }} />

      {}
      <div aria-hidden="true" className="absolute inset-0 pointer-events-none" style={{
      background: "radial-gradient(ellipse 55% 45% at 50% 50%, hsl(220 22% 6% / 0.55) 0%, hsl(220 22% 6% / 0.25) 55%, transparent 80%)"
    }} />

      <div className="relative z-10 mx-auto flex min-h-[80svh] max-w-[900px] flex-col items-center justify-center px-6 py-[clamp(112px,14vw,200px)] text-center sm:px-8">
        <span className="vault-eyebrow font-default mb-8 text-[12px] font-medium uppercase" style={{
        opacity: 0,
        letterSpacing: "0.22em",
        color: "hsl(210 20% 98%)"
      }}>
          Eurocontrol
        </span>

        <h2 className="font-default text-primary-foreground mb-8 font-medium" style={{
        fontSize: "clamp(44px, 7.2vw, 116px)",
        letterSpacing: "-0.035em",
        lineHeight: 0.96
      }}>
          <span className="vault-headline-line block" style={{
          opacity: 0
        }}>
            Engenharia de
          </span>
          <span className="vault-headline-line block" style={{
          opacity: 0
        }}>
            Pulverização.
          </span>
        </h2>

        <p className="vault-body font-default mx-auto mb-12 max-w-[640px]" style={{
        opacity: 0,
        fontSize: "clamp(17px, 1.15vw, 19px)",
        lineHeight: 1.55,
        color: "hsl(210 20% 98% / 0.85)",
        letterSpacing: "-0.005em"
      }}>
          Soluções técnicas avançadas para a indústria. Representante exclusivo da Spraying Systems Co. em Portugal.
        </p>

        <div className="vault-cta relative inline-flex" style={{
        opacity: 0
      }}>
          {}
          <div aria-hidden="true" className="vault-glow absolute inset-0 rounded-lg" style={{
          opacity: 0.45,
          boxShadow: "0 0 96px -16px hsl(215 90% 45% / 0.85)",
          background: "hsl(215 90% 45% / 0.25)",
          filter: "blur(8px)"
        }} />
          <Button asChild className="bg-card text-card-foreground hover:bg-card/90 relative h-16 gap-3 rounded-lg px-9 text-base font-medium shadow-lg transition-all duration-300">
            <Link to="/ContactsPage" className="inline-flex items-center gap-3">
              <span>Consulte-nos</span>
              <span className="bg-primary text-primary-foreground inline-flex h-8 w-8 items-center justify-center rounded-lg transition-transform duration-300 group-hover:rotate-45" style={{
              color: "hsl(215 80% 20%)"
            }}>
                <ArrowUpRight className="h-4 w-4" />
              </span>
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}